import React, { lazy, Suspense } from 'react';

const AppManagement = lazy(() =>
  import(/* webpackChunkName: "app-management" */ './AppManagement'),
);

export const LazyAppManagement: React.FunctionComponent<{
  section?: string;
  subsection?: string;
}> = ({ section, subsection }) => {
  return (
    <Suspense fallback={null}>
      <AppManagement section={section} subsection={subsection} />
    </Suspense>
  );
};
